export default {
  title: 'Moje dokumenty',
  description: 'Twoje przesłane dokumenty firmowe. Możesz je pobrać lub zastąpić w dowolnym momencie.',
  document_types: {
    owner_document: 'Dokument tożsamości właściciela',
    business_document: 'Dokument firmowy',
  },
  kinds: {
    vat_registration: 'Rejestracja VAT',
    trade_registration: 'Rejestracja działalności',
    trade_license: 'Licencja handlowa',
    commercial_register_extract: 'Wyciąg z rejestru handlowego',
    financial_statements: 'Sprawozdania finansowe',
    other: 'Inne',
    passport: 'Paszport',
    driver_license: 'Prawo jazdy',
    id_card: 'Dowód osobisty',
    residence_permit: 'Zezwolenie na pobyt',
  },
  sides: {
    front: 'Przód',
    back: 'Tył',
  },
  fields: {
    document: 'Dokument',
    kind: 'Rodzaj',
    side: 'Strona',
    uploaded_at: 'Przesłano',
    expires_at: 'Wygasa',
    retained_until: 'Przechowywany do',
    deleted_at: 'Usunięto',
    storage_deleted_at: 'Trwale usunięto',
    actions: 'Akcje',
  },
  values: {
    no_file_name: '—',
    version: 'v{{version}}',
  },
  filters: {
    type_placeholder: 'Filtruj według typu dokumentu',
    kind_placeholder: 'Filtruj według rodzaju',
  },
  retention: {
    deletable: 'Usuwalny',
    tooltip:
      'Prawo niemieckie (GoBD / §147 AO) zobowiązuje nas do przechowywania tego dokumentu do {{date}}. Można go usunąć dopiero po tej dacie.',
    tooltip_no_date: 'Ten dokument podlega ustawowemu okresowi przechowywania i nie może jeszcze zostać usunięty.',
  },
  buttons: {
    download: 'Pobierz',
    download_front: 'Pobierz przód',
    download_back: 'Pobierz tył',
    reupload: 'Prześlij ponownie',
    delete: 'Usuń',
  },
  empty: 'Nie przesłałeś jeszcze żadnych dokumentów.',
  delete_modal: {
    title: 'Usuń dokument',
    description:
      'Wybierz sposób usunięcia dokumentu. „Usuń" archiwizuje go i ukrywa z listy. „Usuń trwale" kasuje pliki bezpowrotnie i jest możliwe dopiero po upływie ustawowego okresu przechowywania.',
    delete: 'Usuń',
    permanently_delete: 'Usuń trwale',
    cancel: 'Anuluj',
    retention_alert:
      'Te dokumenty podlegają ustawowym okresom przechowywania zgodnie z prawem niemieckim (GoBD / §147 AO). Trwałe usunięcie dokumentu nieodwracalnie kasuje jego pliki.',
  },
  reupload_modal: {
    title: 'Prześlij dokument ponownie',
    description: 'Prześlij nową wersję tego dokumentu. Poprzednia wersja zostanie zastąpiona.',
    type: {
      label: 'Typ dokumentu',
      placeholder: 'Wybierz typ dokumentu',
    },
    kind: {
      label: 'Rodzaj dokumentu',
      placeholder: 'Wybierz rodzaj dokumentu',
    },
    front: {
      label: 'Przód dokumentu',
    },
    back: {
      label: 'Tył dokumentu (opcjonalny dla niektórych dokumentów)',
    },
    expires_at: {
      label: 'Data ważności dokumentu',
      placeholder: 'Wybierz datę ważności',
    },
    buttons: {
      select_file: 'Wybierz plik',
      submit: 'Prześlij',
      cancel: 'Anuluj',
    },
  },
  toasts: {
    download_error: 'Nie udało się pobrać dokumentu.',
    delete_success: 'Dokument został pomyślnie usunięty.',
    delete_error: 'Nie udało się usunąć dokumentu.',
    reupload_success: 'Dokument został pomyślnie przesłany.',
    reupload_error: 'Nie udało się przesłać dokumentu.',
  },
};
